import React from "react";
import { createScope, partnerCenterTheme } from "@harmony/enablers/react";
import {
  dropdown,
  filterPill,
  menu,
  menuItem
} from '@harmony/enablers/react';

const scope = createScope({
    basePath: "https://harmonyenablers.microsoft.com/npm/@harmony/enablers/6.34.1",
  reactInstance: React,
  styles: [partnerCenterTheme]
});


export const Dropdown = scope.forReact(dropdown);
export const FilterPill = scope.forReact(filterPill);
export const Menu = scope.forReact(menu);
export const MenuItem = scope.forReact(menuItem);